import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1Header from "./S1_Header";
import Section2About from "./S2_Tools";
import Card from "./card";

import S6Tokenomics from "./S4_Tokenomics";
import Data from "./S3_data";

import Section8Team from "./S6_Faq";
import Section9Footer from "./S7_Footer";

import { PageWrapper } from "../../Styles/style";
const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>

      <PageWrapper style={{overflow:"hidden"}}>

          {/* <Menu/> */}
          <Section1Header />
          <Section2About />
          <Card />
          <S6Tokenomics />
          <Data />
          <div style={{backgroundColor:'#00FF00'}}>
            <Section8Team />
          <Section9Footer />
          </div>
      </PageWrapper>
      
    </>
  );
};

export default MainPage;
